/* =========================================================
   Human Hair Bundle — Buy Box
   - Variant selection is LOCAL ONLY.
   - Does NOT touch window.location, history, or dispatch
     any global "variant:change" events. Other surfaces
     (cart, recently viewed, share links) stay on the
     canonical first-available variant.
   - Loox is left alone — its own injector renders blocks.
   ========================================================= */
(function () {
  'use strict';

  function init(section) {
    if (section.dataset.hhbBound === '1') return;
    section.dataset.hhbBound = '1';

    var hero = section.querySelector('[data-bundle-hero]');
    var form = section.querySelector('form[action*="/cart/add"]') || section.querySelector('form');
    var hiddenId = section.querySelector('[data-bundle-variant-id]');
    var cta = section.querySelector('[data-bundle-cta]');
    var gallery = section.querySelector('[data-bundle-gallery]');
    var dots = section.querySelectorAll('[data-bundle-dots] .hhb__gallery-dot');
    var slides = section.querySelectorAll('.hhb__gallery-slide');
    var ctaLabel = section.querySelector('[data-bundle-cta-label]');
    var ctaPrice = section.querySelector('[data-bundle-cta-price]');
    var sticky = section.querySelector('[data-bundle-sticky]');
    var stickyName = section.querySelector('[data-bundle-sticky-name]');
    var stickyPrice = section.querySelector('[data-bundle-sticky-price]');
    var stickyCta = section.querySelector('[data-bundle-sticky-cta]');
    var cards = section.querySelectorAll('[data-bundle-card]');

    function selectCard(card) {
      if (!card) return;
      var available = card.getAttribute('data-variant-available') === 'true';
      if (!available) return; // sold-out cards are inert

      // Update card states (radio behavior, scoped to this section only)
      cards.forEach(function (c) {
        var isThis = c === card;
        c.classList.toggle('is-selected', isThis);
        c.setAttribute('aria-checked', isThis ? 'true' : 'false');
      });

      var id = card.getAttribute('data-variant-id');
      var title = card.getAttribute('data-variant-title');
      var price = card.getAttribute('data-variant-price');
      var imgSrc = card.getAttribute('data-variant-image');
      var imgSrcset = card.getAttribute('data-variant-image-srcset');
      var imgZoom = card.getAttribute('data-variant-image-zoom');
      var imgAlt = card.getAttribute('data-variant-image-alt');

      // Update form (this is the ONLY persistent state change)
      if (hiddenId) hiddenId.value = id;

      // Update CTA
      if (cta) {
        cta.disabled = false;
        cta.removeAttribute('aria-disabled');
      }
      if (ctaLabel && ctaPrice) {
        ctaPrice.textContent = price;
      } else if (ctaLabel) {
        ctaLabel.innerHTML = 'Add to cart — <span data-bundle-cta-price>' + price + '</span>';
      }

      // Update sticky bar
      if (stickyName) stickyName.textContent = title;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyCta) {
        stickyCta.disabled = false;
        stickyCta.textContent = 'Add to cart';
      }

      // Swap hero image (the variant-keyed first slide) and update its zoom-src
      if (hero && imgSrc) {
        hero.classList.add('is-swapping');
        var preload = new Image();
        preload.onload = function () {
          hero.src = imgSrc;
          if (imgSrcset) hero.srcset = imgSrcset;
          if (imgAlt) hero.alt = imgAlt;
          hero.classList.remove('is-swapping');
          // Sync the zoom-src on the slot's wrapping button so lightbox shows variant
          var heroBtn = hero.closest('[data-bundle-zoom-trigger]');
          if (heroBtn && imgZoom) heroBtn.setAttribute('data-zoom-src', imgZoom);
        };
        preload.onerror = function () { hero.classList.remove('is-swapping'); };
        preload.src = imgSrc;

        // Snap gallery back to slide 0 so user sees the new variant
        if (gallery) {
          try { gallery.scrollTo({ left: 0, behavior: 'smooth' }); }
          catch (e) { gallery.scrollLeft = 0; }
        }
      }

      // EXPLICITLY: no history change, no global event dispatch.
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    // Sticky CTA proxies to the form's submit
    if (stickyCta && form) {
      stickyCta.addEventListener('click', function () {
        if (stickyCta.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    // Show sticky bar after the inline CTA scrolls out of view
    if (sticky && cta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      io.observe(cta);
    }

    // ----- Gallery dots: sync active dot to current slide -----
    if (gallery && slides.length > 1 && dots.length === slides.length && 'IntersectionObserver' in window) {
      var slideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10) || 0;
            dots.forEach(function (d, i) {
              var on = i === idx;
              d.classList.toggle('is-active', on);
              d.setAttribute('aria-selected', on ? 'true' : 'false');
            });
          }
        });
      }, { root: gallery, threshold: [0, 0.55, 1] });
      slides.forEach(function (s) { slideObserver.observe(s); });
    }

    // Tap a dot → scroll to that slide
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10) || 0;
        var target = slides[idx];
        if (!gallery || !target) return;
        try {
          gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        } catch (e) {
          gallery.scrollLeft = target.offsetLeft;
        }
      });
    });

    // ----- Zoom lightbox (local to section, every slide is a trigger) -----
    var zoomTriggers = section.querySelectorAll('[data-bundle-zoom-trigger]');
    var lightbox = section.querySelector('[data-bundle-lightbox]');
    var lightboxImg = section.querySelector('[data-bundle-lightbox-img]');
    var lightboxClose = section.querySelector('[data-bundle-lightbox-close]');

    function openZoom(btn) {
      if (!lightbox || !lightboxImg || !btn) return;
      var src = btn.getAttribute('data-zoom-src');
      var img = btn.querySelector('img');
      if (!src && img) src = img.currentSrc || img.src;
      var alt = img ? img.alt : '';
      if (!src) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt;
      lightbox.hidden = false;
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      document.documentElement.classList.add('hhb-no-scroll');
    }
    function closeZoom() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      document.documentElement.classList.remove('hhb-no-scroll');
      setTimeout(function () {
        if (!lightbox.classList.contains('is-open')) {
          lightbox.hidden = true;
          if (lightboxImg) lightboxImg.removeAttribute('src');
        }
      }, 200);
    }

    zoomTriggers.forEach(function (btn) {
      btn.addEventListener('click', function () { openZoom(btn); });
    });
    if (lightboxClose) lightboxClose.addEventListener('click', closeZoom);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('hhb__lightbox-stage')) {
          closeZoom();
        }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeZoom();
    });
  }

  function boot() {
    document.querySelectorAll('[data-bundle-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify theme editor section load (admin preview only)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector ? e.target.querySelector('[data-bundle-section]') : null;
      if (sec) init(sec);
    });
  }
})();
